// extracted by mini-css-extract-plugin
export default {"Box":"ChecksStatusBadgeFooter-module__Box--A9a95"};